import styled from 'styled-components';

export const StyledUnorderedList = styled.ul`
  padding-left: 0;
`;
